var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    banner: true,
    rounded: _vm.rounded,
    outlined: _vm.outlined,
    [_vm.color]: _vm.color,
    'loading-skeleton': _vm.loading
  },style:({ padding: _vm.padding })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }